<template>
  <v-container
    id="data-management"
    tag="section"
  >
    <base-resource-grid
      color="purple"
      icon="mdi-domain"
      plural-name="Carriers"
      singular-name="Carrier"
      allow-expand
      :headers="headers"
      :resource="carrierResource"
      :actions="actions"
      @handleAction="handleAction"
    >
      <template v-slot:editForm="bindings">
        <v-row>
          <v-col
            cols="12"
          >
            <v-text-field
              v-model="bindings.editedItem.carrier"
              :error-messages="bindings.formErrors.Carrier"
              label="Carrier"
            />
          </v-col>
        </v-row>
      </template>
    </base-resource-grid>
    <base-history-dialog
      resource-endpoint="carrierHistory/"
      id-field="carrierId"
      title-field="carrier"
      color="purple"
      :columns="headers"
      :item="historyItem"
      @hide="historyItem = null"
    />
  </v-container>
</template>

<script>
  import TroodyApi from '@/services/troody/TroodyApi'

  export default {
    name: 'Carriers',

    data: () => ({
      headers: [
        {
          text: 'Carrier',
          value: 'carrier',
        },
      ],

      actions: [
        {
          color: 'info',
          icon: 'mdi-information-variant',
          action: 'history',
        },
      ],

      carrierResource: new TroodyApi('carrier/'),

      historyItem: null,
    }),

    methods: {
      handleAction (action, data) {
        if (action === 'history') {
          this.historyItem = data
        }
      },
    },
  }
</script>
